import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from '../../../../core/shared/service/crud/mvs-crud.service';

/**
 * AI:
 * Status: 'implemented'
 * Type: Service
 * SubType: CRUD Entity Service
 * Reason: CRUD for {@code dq.DqAuditRun} over {@code /mvsa/dq/auditRuns}.
 *
 * READ-ONLY in practice. STARTING a run is not offered by the frontend at all: the backend endpoint
 * {@code POST /mvsa/dq/auditRuns/start} is synchronous and returns only when the run has finished,
 * which at the signed-off target size would block the browser for minutes. Runs are started through
 * the {@code jb} job (04-bauauftrag.md §8). The „Prüfläufe" list is therefore a log.
 *
 * The route segment is a STRING LITERAL from the backend controller's {@code @RequestMapping} and is
 * derived from nothing — neither from the entity name nor from the alias. It is written out
 * verbatim here and must NEVER be assembled.
 */
@Injectable({providedIn: 'root'})
export class DqAuditRunService extends MvsCrudService {

    constructor(protected override http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/dq/auditRuns');
    }

    override getObjectIcon(): string {
        return 'fa-solid fa-clock-rotate-left';
    }

    override getObjectLabels(): string[] {
        return ['Prüflauf', 'Prüfläufe'];
    }
}
